import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import * as format from '../../../lib/format'
import ModalFeedback from '../ModalFeedback/ModalFeedback'
import Text from '../Text/Text'
import Button from '../Button/Button'

const AuthResentModal = (props) => {
  const { modalId, phone } = props

  const id = useSelector((state) => state.modalReducer.content.id)
  const visible = modalId && id === modalId

  const dispatch = useDispatch()
  const handleClose = () =>
    dispatch(reducks.resources.modal.actions.resetModal())

  return (
    <ModalFeedback visible={visible} closeCallback={() => handleClose()}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Text color="gray" variation="dark" size="lg">
          Reenviamos o código de confirmação
        </Text>
        <Text
          font="custom"
          size="sm"
          color="gray"
          variation="light"
          margin="24px 0px 6px 0px"
        >
          Reenviamos o SMS com o código de autenticação.
        </Text>
        <Text ont="custom" size="sm" color="gray" variation="dark">
          {format.toFormatPhone(phone)}
        </Text>

        <Button
          type="secondary"
          margin="24px 0 0"
          width="160px"
          onClick={() => handleClose()}
        >
          <Text font="custom" color="white" size="xs" value="OK" bold />
        </Button>
      </div>
    </ModalFeedback>
  )
}

AuthResentModal.defaultProps = {
  modalId: null,
  phone: undefined
}

AuthResentModal.propTypes = {
  modalId: PropTypes.string,
  phone: PropTypes.number
}

export default AuthResentModal
